<template>
    <div class="container-fluid mt-5">
      <div>
        <card
          class="no-border-card"
          body-classes="px-0 pb-1"
          footer-classes="pb-2"
        >
          <template slot="header">
            <div class="row">
              <div class="col-6">
                <h3 class="mb-0">Corridas</h3>
              </div>
              <div class="col-6 text-right">
                <base-button class="hover-apolo" type="default" icon size="sm" @click="addModal()">
                  <span class="btn-inner--icon"
                    ><i class="fas fa-plus"></i
                  ></span>
                  <span class="btn-inner--text">Corridas</span>
                </base-button>
              </div>
            </div>
          </template>
          <div>
            <div
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
            <el-select
                class="select-primary pagination-select"
                v-model="pagination.perPage"
                placeholder="Datos por página"
              >
                <el-option
                  class="select-primary"
                  v-for="item in pagination.perPageOptions"
                  :key="item.value"
                  :label="item.descripcion"
                  :value="Number(item.value)"
                >
                </el-option>
            </el-select>
            <div>
                <form class="apolo-borde">
                  <base-input
                    v-model="query"
                    type="search"
                    append-icon="fas fa-search"
                    placeholder="Buscar..."
                    clearable
                    inputClasses="apolo-borde"
                  />
                </form>
            </div>
            <date-picker
              v-model="fecha_salida"
              :placeholder="'Fecha de salida'"
              :format="'DD-MM-YYYY'"
              :lang="'es'"
            ></date-picker>

            <date-picker
              v-model="hora_salida"
              :placeholder="'Hora de salida'"
              format="hh:mm"
              type="time"
            ></date-picker>
          </div>
          <div class="row mb-4 mr-1">
            <div class="col-3 offset-3">
              <multiselect v-model="ruta" :options="rutas" :multiple="false" :close-on-select="true" :clear-on-select="false" :preserve-search="true" placeholder="Seleccione ruta" label="nombre" track-by="id" :showLabels="false"></multiselect>
            </div>
            <div class="col-3">
              <multiselect v-model="terminal_origen" :options="terminales" :multiple="false" :close-on-select="true" :clear-on-select="false" :preserve-search="true" placeholder="Seleccione terminal origen" label="nombre" track-by="id" :showLabels="false"></multiselect>
            </div>
            <div class="col-3">
              <multiselect v-model="terminal_destino" :options="terminales" :multiple="false" :close-on-select="true" :clear-on-select="false" :preserve-search="true" placeholder="Seleccione terminal destino" label="nombre" track-by="id" :showLabels="false"></multiselect>
            </div>
          </div>
          <div style="overflow-x: scroll; width: auto;">
            <el-table
              class="table-responsive align-items-center table-flush"
              header-row-class-name="thead-light"
              :data="corridas"
              @sort-change="sortChange"
            >
              <div slot="empty" v-if="loading">
                <img src="/img/loading.gif" style="height: 100px; width: 100px" />
              </div>
  
              <div slot="empty" v-if="corridas">
                Sin datos disponibles
              </div>
  
              <el-table-column label="#" prop="id" />
              <el-table-column label="Ruta" min-width="180px">
                <div slot-scope="{ row }" class="table-actions">
                  <!--
                  <span v-if="row.relationships.grupo_corrida.ruta">{{row.relationships.grupo_corrida.ruta.terminal_origen.abreviatura +'-'+ row.relationships.grupo_corrida.ruta.terminal_destino.abreviatura}}</span>
                  -->
                  <span v-if="row.relationships.grupo_corrida.ruta"> {{ row.relationships.grupo_corrida.ruta.nombre }}</span>
                </div>
              </el-table-column>
              <el-table-column label="Terminal Origen" min-width="180px" prop="relationships.grupo_corrida.ruta.terminal_origen.nombre" />
              <el-table-column label="Terminal Destino" min-width="180px" prop="relationships.grupo_corrida.ruta.terminal_destino.nombre" />
              <el-table-column label="Fecha Salida" min-width="180px">
                <div slot-scope="{ row }" class="table-actions">
                  <span>{{row.attributes.fecha_salida + " " + row.attributes.hora_salida | moment('DD-MM-YYYY HH:mm')}}</span>
                </div>
              </el-table-column>
              <el-table-column label="Layout Autobus" min-width="180px" prop="relationships.layout.nombre" />
              <el-table-column label="# Asientos" min-width="130px" prop="relationships.layout.numero_asientos" />
              <el-table-column label="# Unidad" min-width="180px">
                <div slot-scope="{ row }" class="table-actions">
                  <span v-if="row.relationships.unidad" @click="changeUnidadTable(row)" style="cursor:pointer;">{{row.relationships.unidad.numero_economico}}</span>
                  <span v-else @click="changeUnidadTable(row)" style="cursor:pointer;">Pendiente</span>
                </div>
              </el-table-column>
              <el-table-column label="Operadores" min-width="180px">
                <div slot-scope="{ row }" class="table-actions">
                  <span v-if="row.relationships.operador1" @click="changeOperadorTable(row)" style="cursor:pointer;">{{row.relationships.operador1.nombre+' '+row.relationships.operador1.apellidos}}</span>
                  <br v-if="row.relationships.operador2">
                  <span v-if="row.relationships.operador2" @click="changeOperadorTable(row)" style="cursor:pointer;">{{row.relationships.operador2.nombre+' '+row.relationships.operador2.apellidos}}</span>
                  <span v-if="!row.relationships.operador1 && !row.relationships.operador2" @click="changeOperadorTable(row)" style="cursor:pointer;">Pendiente</span>
                </div>
              </el-table-column>
              <el-table-column label="# Tramos seleccionados" min-width="180px" prop="relationships.grupo_corrida.tramos.length" />
              <el-table-column min-width="165px">
                <div slot-scope="{ row }" class="table-actions">
                  <base-button class="hover-apolo" type="primary" icon size="sm" @click="adminCorrida(row)">
                    <span class="btn-inner--text">Administrar</span>
                  </base-button>
                </div>
            </el-table-column>
            </el-table>
          </div>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center flex-wrap"
          >
            <base-pagination
              class="pagination-no-border justify-content-right"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            />
          </div>
        </card>
      </div>
      <!-- MODAL CREATE -->
      <modal :show.sync="showAddModal" modal-classes="modal-primary" size="xl">
        <h6 slot="header" class="mb-0 modal-title">Información de corrida(s) a crear</h6>
        <p style="color: red !important">El tiempo de procesamiento puede variar dependiendo de la cantidad de tramos y fechas seleccionadas. <br>Por ejemplo: para 3 meses de una corrida diaria con 120 tramos toma 10 minutos.</p>
        <pulse-loader class="text-center" v-if="loadingSpinner" :loading="loadingSpinner" :color="color" :size="size"></pulse-loader>
        <form v-else class="new-event--form" @submit.prevent="addCorrida">
          <div class="row"> 
            <div class="col-7">
              <base-input label="Layout">
                <multiselect v-model="corrida.layout" :options="layouts" :multiple="false" :close-on-select="true" :clear-on-select="false" :preserve-search="true" placeholder="Selecccione layout" label="nombre" track-by="id" :showLabels="false"></multiselect>
              </base-input>
              <validation-error :errors="apiValidationErrors.layout_id" />
              <base-input label="Ruta">
                <multiselect v-model="corrida.ruta" :options="rutas" :multiple="false" :close-on-select="true" :clear-on-select="false" :preserve-search="true" placeholder="Seleccione ruta" label="nombre" track-by="id" :showLabels="false"></multiselect>
              </base-input>
              <validation-error :errors="apiValidationErrors.ruta_id" />
              <base-input label="Días">
                <div class="row ml-1">
                  <base-checkbox class="col-1" v-for="dia in dias" :key="dia.id" v-model="dia.status">
                    {{ dia.nombre }}
                  </base-checkbox>
                </div>
              </base-input>
              <validation-error :errors="apiValidationErrors.dias" />
            </div>
            <div class="col-5">
              <base-input label="Fecha inicio de creación">
                <date-picker
                  v-model="corrida.fecha_inicio"
                  :format="'DD-MM-YYYY'"
                  :lang="'es'"
                ></date-picker>
              </base-input>
              <validation-error :errors="apiValidationErrors.fecha_inicio" />
              <base-input label="Fecha fin de creación">
                <date-picker
                  v-model="corrida.fecha_fin"
                  :format="'DD-MM-YYYY'"
                  :lang="'es'"
                ></date-picker>
              </base-input>
              <validation-error :errors="apiValidationErrors.fecha_fin" />
              <base-input label="Hora de salida">
                <date-picker
                  v-model="hora_salida_select"
                  format="HH:mm"
                  type="time"
                ></date-picker>
              </base-input>
              <validation-error :errors="apiValidationErrors.hora_salida" />
              <span v-if="validacion.mensaje != null">
                <small class="argon-error" v-text="validacion.mensaje"/>
              </span>
              <validation-error :errors="apiValidationErrors.tramos" />
            </div>
          </div>
          <h6 slot="header" class="mb-0 modal-title">Tramos de ruta <span v-if="corrida.ruta">{{corrida.ruta.nombre}}</span></h6>
          <el-table
              class="table-responsive align-items-center table-flush"
              header-row-class-name="thead-light"
              :data="rutaTramos"
              @sort-change="sortChange"
              @selection-change="handleSelectionChange"
            >
              <div slot="empty" v-if="loading">
                <img src="/img/loading.gif" style="height: 100px; width: 100px" />
              </div>
  
              <div slot="empty" v-if="rutaTramos">
                Sin datos disponibles
              </div>
              
              <el-table-column label="Terminal Origen" prop="tramo.terminal_origen.nombre" />
              <el-table-column label="Terminal Destino" prop="tramo.terminal_destino.nombre" />
              <el-table-column label="Tiempo Tramo" prop="tramo.tiempo" />
              <el-table-column label="Tiempo Origen" prop="tiempo_ruta_tramo" />
              <el-table-column label="Pasa" type="selection" width="55" />
          </el-table>
          <input type="hidden" class="new-event--start"/>
          <input type="hidden" class="new-event--end"/>
        </form>
  
        <template slot="footer">
          <button type="submit" class="btn btn-default hover-apolo new-event--add" :disabled="disabledButtonAddCorrida" @click="addCorrida">Guardar</button>
          <button type="button" class="btn btn-primary hover-apolo ml-auto" @click="closeModal">Cerrar</button>
        </template>
      </modal>
      <!-- MODAL ADMINISTRAR -->
      <modal :show.sync="showAdminModal" modal-classes="modal-primary" size="xl">
        <div class="row">
          <h6 slot="header" class="mb-0 col-4 modal-title">Información de corrida #<span v-if="corrida_admin.id">{{corrida_admin.id}}</span></h6>
          <button class="col-3 btn btn-default hover-apolo" type="button" @click="getGrupoCorrida(corrida_admin.grupo_corrida_id)">Ver grupo de corridas</button>
          <div class="col-5"></div>
        </div>
        <br>
        <form class="new-event--form" @submit.prevent="updateCorrida">
          <div class="row">
            <div class="col-4">
              <span @click="showChangeLayout(corrida_admin.id)">Layout:<span style="cursor: pointer; color: #0068a0;"> {{corrida_admin.layout_nombre}}</span></span>
            </div>
            <div class="col-4">
              <span>Fecha de salida: {{corrida_admin.fecha_salida | moment('DD-MM-YYYY')}}</span>
            </div>
            <div class="col-4">
              <span>Unidad: 
                <a @click="showChangeUnidad" v-if="corrida_admin.unidad" style="cursor:pointer; color: #0068a0;">{{corrida_admin.unidad}}</a>
                <a @click="showChangeUnidad" v-else style="cursor:pointer; color: #0068a0;">Pendiente</a>
              </span>
            </div>
          </div>
          <div class="row">
            <div class="col-4">
              <span>Ruta: {{corrida_admin.ruta_nombre}}</span>
            </div>
            <div class="col-4">
              <span>Hora de salida: {{corrida_admin.hora_salida | moment('HH:mm')}}</span>
            </div>
            <div class="col-4">
              <span>Operadores:
                <a @click="showChangeOperador" v-if="corrida_admin.operador1" style="cursor:pointer; color: #0068a0;"> {{corrida_admin.operador1}}</a>
                <a @click="showChangeOperador" v-if="corrida_admin.operador2" style="cursor:pointer; color: #0068a0;">, {{corrida_admin.operador2}}</a>
                <a @click="showChangeOperador" v-if="!corrida_admin.operador1 && !corrida_admin.operador2" style="cursor:pointer; color: #0068a0;">Pendiente</a>
              </span>
            </div>
          </div>
          <br>
          <div class="row">
            <button v-show="corrida_admin.active === 1" class="col-2 ml-3 btn btn-default hover-apolo" type="button" @click="deactivateCorrida(corrida_admin.id)">Suspender</button>
            <button v-show="corrida_admin.active === 0" class="col-2 ml-3 btn btn-default hover-apolo" type="button" @click="activateCorrida(corrida_admin.id)">Activar</button>
            <button class="col-3 ml-3 btn btn-default hover-apolo" type="button" @click="listaAbordajeModal(corrida_admin.id)">Lista de abordaje</button>
            <button class="col-2 ml-auto mb-0 btn btn-danger hover-apolo" type="button" :disabled="destroyingCorrida" @click="destroyCorrida(corrida_admin.id)">Eliminar</button>
          </div>
          <br>
          <h6 slot="header" class="mb-0 modal-title">Sub-corridas y tramos disponibles</h6>
          <el-table
              class="table-responsive align-items-center table-flush"
              header-row-class-name="thead-light"
              :data="tramosSubcorridas"
              @sort-change="sortChange"
            >
              <div slot="empty" v-if="loading">
                <img src="/img/loading.gif" style="height: 100px; width: 100px" />
              </div>
  
              <div slot="empty" v-if="tramosSubcorridas">
                Sin datos disponibles
              </div>
  
              <el-table-column label="#" prop="attributes.subcorrida_id" />
              <el-table-column label="Pasa">
                <div slot-scope="{ row }" class="table-actions">
                  <base-checkbox v-model="row.attributes.pasa"></base-checkbox>
                </div>
              </el-table-column>
              <el-table-column label="Terminal Origen" prop="attributes.terminal_origen" />
              <el-table-column label="Terminal Destino" prop="attributes.terminal_destino" />
              <el-table-column label="Tiempo Tramo" prop="attributes.tiempo" />
              <el-table-column label="Tiempo Origen" prop="attributes.tiempo_ruta_tramo" />
              <el-table-column label="Fecha Salida">
                <div slot-scope="{ row }" class="table-actions">
                  <span v-if="row.attributes.fecha_salida">{{row.attributes.fecha_salida | moment('DD-MM-YYYY HH:mm')}}</span>
                  <span v-else>N/A</span>
                </div>
              </el-table-column>
              <el-table-column label="Fecha Llegada">
                <div slot-scope="{ row }" class="table-actions">
                  <span v-if="row.attributes.fecha_llegada">{{row.attributes.fecha_llegada | moment('DD-MM-YYYY HH:mm')}}</span>
                  <span v-else>N/A</span>
                </div>
              </el-table-column> 
          </el-table>
          <input type="hidden" class="new-event--start"/>
          <input type="hidden" class="new-event--end"/>
        </form>
  
        <template slot="footer">
          <button type="submit" class="btn btn-default hover-apolo new-event--add" @click="updateCorrida">Actualizar sub-corridas</button>
          <button type="button" class="btn btn-primary hover-apolo ml-auto" @click="closeModal">Cerrar</button>
        </template>
      </modal>
      <!-- MODAL VER LISTA DE ABORDAJE -->
      <modal :show.sync="showListaAbordajeModal" :hasParent="true" :close-on-backdrop="true" modal-classes="modal-primary" size="lg">
        <div class="row">
          <h6 slot="header" class="mb-0 modal-title col-6">Lista de abordaje de corrida</h6>
          <button class="btn btn-default hover-apolo new-event--add ml-2 col-4" align="right" @click="imprimirListaAbordaje()">Imprimir</button>
        </div>
        <form class="new-event--form">
          <span v-if="TotalVentaCorrida != null">Total de venta corrida: ${{ TotalVentaCorrida }}</span>
          <br>
          <el-table
              class="table-responsive align-items-center table-flush"
              header-row-class-name="thead-light"
              :data="listaAbordaje"
              @sort-change="sortChange"
            >
              <div slot="empty" v-if="loading">
                <img src="/img/loading.gif" style="height: 100px; width: 100px" />
              </div>
  
              <div slot="empty" v-if="listaAbordaje">
                Sin datos disponibles
              </div>
  
              <el-table-column label="Asiento" prop="attributes.numero" width="100px"/>
              <el-table-column label="Categoría" prop="attributes.categoria.nombre" width="150px"/>
              <el-table-column label="Pasajero">
                <div slot-scope="{ row }" class="table-actions">
                  <div v-if="row.attributes.pasajeros">
                    <div v-for="(pasajero, index) in row.attributes.pasajeros" :key="pasajero.id">
                      <span>{{pasajero}}</span> 
                    </div>
                  </div>
                  <div v-else>
                    <span>Sin Boletos</span>
                  </div>
                </div> 
              </el-table-column>
              <el-table-column label="Sube">
                <div slot-scope="{ row }" class="table-actions">
                  <div v-if="row.attributes.pasajeros">
                    <div v-for="(pasajero, index) in row.attributes.pasajeros" :key="pasajero.id">
                      <span>{{ row.attributes.sube[index] }}</span> 
                    </div>
                  </div>
                  <div v-else>
                    <span>-</span>
                  </div>
                </div> 
              </el-table-column>
              <el-table-column label="Baja">
                <div slot-scope="{ row }" class="table-actions">
                  <div v-if="row.attributes.pasajeros">
                    <div v-for="(pasajero, index) in row.attributes.pasajeros" :key="pasajero.id">
                      <span>{{ row.attributes.baja[index] }}</span> 
                    </div>
                  </div>
                  <div v-else>
                    <span>-</span>
                  </div>
                </div> 
              </el-table-column>
              <el-table-column label="Valor Boleto">
                <div slot-scope="{ row }" class="table-actions">
                  <div v-if="row.attributes.valor_venta_boleto">
                    <div v-for="(valor, index) in row.attributes.valor_venta_boleto" :key="valor.id">
                      <span>{{valor}}</span> 
                    </div>
                  </div>
                  <div v-else>
                    <span>-</span>
                  </div>
                </div> 
              </el-table-column>
              <el-table-column label="Descuento">
                <div slot-scope="{ row }" class="table-actions">
                  <div v-if="row.attributes.detalles_descuento">
                    <div v-for="(valor, index) in row.attributes.detalles_descuento" :key="valor.id">
                      <span>{{valor}}</span> 
                    </div>
                  </div>
                  <div v-else>
                    <span>-</span>
                  </div>
                </div> 
              </el-table-column>
          </el-table>
          <input type="hidden" class="new-event--start"/>
          <input type="hidden" class="new-event--end"/>
        </form>
  
        <template slot="footer">
          <button type="button" class="btn btn-primary hover-apolo ml-auto" @click="showListaAbordajeModal = false">Cerrar</button>
        </template>
      </modal>
      <!-- MODAL VER LISTA DE UNIDADES -->
      <modal v-if="this.unidades.length" :show.sync="showChangeUnidadModal" :hasParent="hasParent" modal-classes="modal-primary" size="sm">
        <h6 slot="header" class="mb-0 modal-title">Información de unidad</h6>
        <form class="new-event--form" @submit.prevent="changeUnidad">
          <base-input label="Unidad">
            <multiselect v-model="corrida_admin.unidad_select" :options="unidades" :multiple="false" placeholder="Selecccione unidad" label="numero_economico" track-by="id" :showLabels="false"></multiselect>
          </base-input>
          <input type="hidden" class="new-event--start"/>
          <input type="hidden" class="new-event--end"/>
        </form>
  
        <template slot="footer">
          <button class="btn btn-default hover-apolo new-event--add" @click="changeUnidad()">Guardar</button>
          <button type="button" class="btn btn-primary hover-apolo ml-auto" @click="showChangeUnidadModal = false, corrida_admin.unidad_id = null, corrida_admin.unidad_select = null">Cerrar</button>
        </template>
      </modal>
      <!-- MODAL VER LISTA DE OPERADORES -->
      <modal v-if="operadores.length" :show.sync="showChangeOperadorModal" :hasParent="hasParent" modal-classes="modal-primary" size="sm">
        <h6 slot="header" class="mb-0 modal-title">Información de operador</h6>
        <form class="new-event--form" @submit.prevent="changeOperador">
          <base-input label="Operador 1">
            <multiselect v-model="corrida_admin.operador1_select" :options="operadores" placeholder="Selecccione operador 1" :custom-label="nombreCompleto" track-by="id" :showLabels="false"></multiselect>
          </base-input>
          <span>Opcional:</span>
          <base-input label="Operador 2">
            <multiselect v-model="corrida_admin.operador2_select" :options="operadores" placeholder="Selecccione operador 2" :custom-label="nombreCompleto" track-by="id" :showLabels="false"></multiselect>
          </base-input>
          <input type="hidden" class="new-event--start"/>
          <input type="hidden" class="new-event--end"/>
        </form>
  
        <template slot="footer">
          <button class="btn btn-default hover-apolo new-event--add" @click="changeOperador()">Guardar</button>
          <button type="button" class="btn btn-primary hover-apolo ml-auto" @click="showChangeOperadorModal = false, corrida_admin.operador1_id = null, corrida_admin.operador1_select = null, corrida_admin.operador2_id = null, corrida_admin.operador2_select = null">Cerrar</button>
        </template>
      </modal>
      <!-- MODAL VER CAMBIAR LAYOUT -->
      <modal :show.sync="showChangeLayoutModal" :hasParent="true" modal-classes="modal-primary" size="xl">
        <h6 slot="header" class="mb-0 modal-title">Información de layout</h6>
        <pulse-loader class="text-center" v-if="loadingSpinner" :loading="loadingSpinner" :color="color" :size="size"></pulse-loader>
        <form v-else class="new-event--form">
          <span>Layout actual:</span>
          <div v-if="corrida_layout != null">
            <div v-if="mostrarNivelUno">
              <div v-for="(column,indexColumn) in corrida_layout.estructura[0]" :key="indexColumn" class="d-flex flex-row align-content-around flex-wrap">
                <box-item 
                  :cambio_layout="cambio_layout"
                  :iniciaCambiaAsiento="iniciaCambiaAsiento"
                  :corrida_layout="corrida_layout"
                  :ref="'old'+(indexColumn).toString()+indexFila"
                  :id="'old'+(indexColumn).toString()+indexFila"
                  v-model="corrida_layout.estructura[0][indexColumn][indexFila]" 
                  v-for="(fila,indexFila) in column" :key="(indexColumn).toString()+indexFila"
                ></box-item>
              </div>
            </div>
            <div v-if="mostrarNivelDos">
              <div v-if="parseInt(corrida_layout.niveles) === 2" class="col-12">
                <div v-for="(column,indexColumn) in corrida_layout.estructura[1]" :key="indexColumn" class="d-flex flex-row align-content-around flex-wrap">
                  <box-item 
                    :cambio_layout="cambio_layout"
                    :iniciaCambiaAsiento="iniciaCambiaAsiento"
                    :corrida_layout="corrida_layout"
                    :ref="'oldTwo'+(indexColumn).toString()+indexFila"
                    :id="'oldTwo'+(indexColumn).toString()+indexFila"
                    v-model="corrida_layout.estructura[1][indexColumn][indexFila]" 
                    v-for="(fila,indexFila) in column" :key="(indexColumn).toString()+indexFila"
                  ></box-item>
                </div>
              </div>
            </div>
            <br>
            <div v-if="parseInt(corrida_layout.niveles) === 2" class="App__basic-example-controls text-center">
              <button class="btn btn-default hover-apolo" @click.prevent="nivelUno()">
                &laquo; Nivel 1
              </button>
              <button class="btn btn-default hover-apolo" @click.prevent="nivelDos()">
                Nivel 2 &raquo;
              </button>
            </div>
          </div>
          <div v-if="cambiaAsiento === true"  class="alert alert-dark col-6" role="alert">
            A continuación, selecciona un asiento disponible del nuevo layout.
          </div>
          <br>
          <multiselect :disabled="selectLayout" @input="createNewLayout" v-model="cambio_layout.layout" :options="layouts" :multiple="false" :close-on-select="true" :clear-on-select="false" :preserve-search="true" placeholder="Selecccione layout nuevo" label="nombre" track-by="id" :showLabels="false"></multiselect>
          <span v-if="cambio_layout.layout != null">Nuevo layout:</span>
          <div v-if="cambio_layout.layout != null">
            <div v-if="mostrarNivelUnoNuevo">
              <div v-for="(column,indexColumn) in new_layout.estructura[0]" :key="indexColumn" class="d-flex flex-row align-content-around flex-wrap">
                <box-item-new 
                  :asientoACopiar="asientoACopiar"
                  :terminaCambioAsiento="terminaCambioAsiento"
                  :cambiaAsiento="cambiaAsiento"
                  :new_layout="new_layout"
                  :ref="'new'+(indexColumn).toString()+indexFila"
                  :id="'new'+(indexColumn).toString()+indexFila"
                  v-model="new_layout.estructura[0][indexColumn][indexFila]" 
                  v-for="(fila,indexFila) in column" :key="(indexColumn).toString()+indexFila"
                ></box-item-new>
              </div>
            </div>
            <div v-if="mostrarNivelDosNuevo">
              <div v-if="parseInt(new_layout.niveles) === 2 && new_layout.estructura[1].length > 0" class="col-12">
                <div v-for="(column,indexColumn) in new_layout.estructura[1]" :key="indexColumn" class="d-flex flex-row align-content-around flex-wrap">
                  <box-item-new
                    :asientoACopiar="asientoACopiar"
                    :terminaCambioAsiento="terminaCambioAsiento"
                    :cambiaAsiento="cambiaAsiento"
                    :new_layout="new_layout"
                    :ref="'newTwo'+(indexColumn).toString()+indexFila"
                    :id="'newTwo'+(indexColumn).toString()+indexFila"
                    v-model="new_layout.estructura[1][indexColumn][indexFila]" 
                    v-for="(fila,indexFila) in column" :key="(indexColumn).toString()+indexFila"
                  ></box-item-new>
                </div>
              </div>
            </div>
            <br>
            <div v-if="parseInt(new_layout.niveles) === 2" class="App__basic-example-controls text-center">
              <button class="btn btn-default hover-apolo" @click.prevent="nivelUnoNuevo()">
                &laquo; Nivel 1
              </button>
              <button class="btn btn-default hover-apolo" @click.prevent="nivelDosNuevo()">
                Nivel 2 &raquo;
              </button>
            </div>
          </div>
          <input type="hidden" class="new-event--start"/>
          <input type="hidden" class="new-event--end"/>
        </form>
  
        <template slot="footer">
          <button type="submit" class="btn btn-default hover-apolo new-event--add" :disabled="disabledButtonLayoutUpdate" @click="updateLayoutCorrida">Guardar</button>
          <button type="button" class="btn btn-primary hover-apolo ml-auto" @click="closeChangeLayoutModal">Cancelar</button>
        </template>
      </modal>
      <!--MODAL VER GRUPO DE CORRIDAS -->
      <modal :show.sync="showGrupoCorridasModal" :hasParent="true" modal-classes="modal-primary" size="xl">
        <h6 slot="header" class="mb-0 modal-title">Información de grupo de corridas</h6>
        <form v-if="grupo_corridas != null" class="new-event--form">
          <div class="row">
            <div class="col-4">
              <span>Ruta: {{corrida_admin.ruta_nombre}}</span>
            </div>
            <div class="col-4">
              <span>Fecha inicio de creación: {{corrida_admin.fecha_inicio | moment("DD-MM-YYYY")}}</span>
            </div>
            <div class="col-4">
              <span>
                Días: 
                <span v-for="(item,index) of corrida_admin.dias" :key="item.id">
                  {{item.nombre}}<span v-if="index != Object.keys(corrida_admin.dias).length - 1">, </span>
                </span>
              </span>
            </div>
          </div>
          <div class="row">
            <div class="col-4">
              <span>Hora de salida: {{corrida_admin.hora_salida}}</span>
            </div>
            <div class="col-4">
              <span>Fecha fin de creación: {{corrida_admin.fecha_fin | moment("DD-MM-YYYY")}}</span>
            </div>
            <div class="col-4">
              <span>Corridas creadas: {{ grupo_corridas.corridas_creadas }}</span>
            </div>
          </div>
          <br>
          <h6 slot="header" class="mb-0 modal-title">Tramos de ruta {{ countPasaTramos }}</h6>
          <el-table
              class="table-responsive align-items-center table-flush"
              header-row-class-name="thead-light"
              :data="grupo_corridas.tramos_ruta"
              @sort-change="sortChange"
            >
              <div slot="empty" v-if="loading">
                <img src="/img/loading.gif" style="height: 100px; width: 100px" />
              </div>
  
              <div slot="empty" v-if="tramosDeRuta">
                Sin datos disponibles
              </div>

              <el-table-column label="Terminal Origen" prop="terminal_origen" />
              <el-table-column label="Terminal Destino" prop="terminal_destino" />
              <el-table-column label="Tiempo Tramo" prop="tiempo" />
              <el-table-column label="Tiempo Origen" prop="tiempo_ruta_tramo" />
              <el-table-column label="Pasa">
                <div slot-scope="{ row }" class="table-actions">
                  <span v-if="row.pasa_original === true && row.pasa === true"></span>
                  <input type="checkbox" v-if="row.pasa_original === false && row.pasa === false" v-model="row.pasa" @change="checkBoxGrupoCorrida(row)">
                  <input type="checkbox" v-if="row.pasa_original === false && row.pasa === true" v-model="row.pasa" @change="checkBoxGrupoCorrida(row)">
                </div>
              </el-table-column>
          </el-table>
          <br>
          <div class="col-2"></div>
          <div class="text-center col-12">
            <button type="button" class="btn btn-default hover-apolo new-event--add" @click="createSubCorridas">Crear sub-corridas en todas las corridas con salida desde este momento en adelante</button>
          </div>
          <div class="col-2"></div>
          <br>
          <h6 slot="header" class="mb-0 modal-title">Corridas en el grupo</h6>
          <el-table
              class="table-responsive align-items-center table-flush"
              header-row-class-name="thead-light"
              :data="grupo_corridas.corridas"
              @sort-change="sortChange"
            >
              <div slot="empty" v-if="loading">
                <img src="/img/loading.gif" style="height: 100px; width: 100px" />
              </div>
  
              <div slot="empty" v-if="corridasEnGrupo">
                Sin datos disponibles
              </div>
  
              <el-table-column label="#" prop="id" />
              <el-table-column label="Fecha Salida">
                <div slot-scope="{ row }" class="table-actions">
                  <span>{{row.fecha_salida | moment("DD-MM-YYYY hh:mm")}}</span>
                </div>
              </el-table-column>
              <el-table-column label="Layout Autobus" prop="layout.nombre" />
              <el-table-column label="# Asientos" prop="layout.numero_asientos" />
              <el-table-column label="# Unidad">
                <div slot-scope="{ row }" class="table-actions">
                  <span v-if="row.unidad != null">{{ row.unidad.numero_economico }}</span>
                  <span v-else>Pendiente</span>
                </div>
              </el-table-column>
              <el-table-column label="Operadores">
                <div slot-scope="{ row }" class="table-actions">
                  <span v-if="row.operador1 || row.operador2">
                    <span v-if="row.operador1">{{ row.operador1.nombre_operador1 }}</span>
                    <br>
                    <span v-if="row.operador2">{{ row.operador2.nombre_operador12}}</span>
                  </span>
                  <span v-else>Pendiente</span>
                </div>
              </el-table-column>
              <el-table-column label="# Tramos Seleccionados" prop="totalSubcorridas" />
          </el-table>
          <input type="hidden" class="new-event--start"/>
          <input type="hidden" class="new-event--end"/>
        </form>
  
        <template slot="footer">
          <button type="button" class="btn btn-primary hover-apolo ml-auto" @click="showGrupoCorridasModal = false">Cerrar</button>
        </template>
      </modal>
      <!-- MODAL VER LISTA DE LOG -->
      <modal v-if="logGrupoCorridas != null" :show.sync="ModalLogGrupoCorridas" :hasParent="hasParent" modal-classes="modal-primary" size="lg">
        <h6 slot="header" class="mb-0 modal-title">Se ha ejecutado la creación de Sub-Corridas con los siguientes resultados:</h6>
        <form class="new-event--form">
          <div class="card ml-3 mr-3 col-11" style="overflow-y:scroll; height:200px;">
            <div class="card-body" v-for="evento in logGrupoCorridas">
              <span>- {{ evento }}</span><br>
            </div>
          </div>
          <input type="hidden" class="new-event--start"/>
          <input type="hidden" class="new-event--end"/>
        </form>
  
        <template slot="footer">
          <button type="button" class="btn btn-primary hover-apolo ml-auto" @click="ModalLogGrupoCorridas = false, showGrupoCorridasModal = false">Cerrar</button>
        </template>
      </modal>
    </div>
  </template>
  <script>
  import Vue from 'vue';
  import {Impresora} from "@/printer/Impresora.js";
  import ImpresionListaAbordaje from "./ImpresionListaAbordaje.vue";
  import { BasePagination, Modal } from "@/components/";
  import DatePicker from 'vue2-datepicker';
  import 'vue2-datepicker/index.css';
  import BoxItem from "./BoxItem.vue";
  import BoxItemNew from "./BoxItemNew.vue";
  import {
    Table,
    TableColumn,
    DropdownMenu,
    DropdownItem,
    Dropdown,
    Tooltip,
    Select,
    Option,
    RadioButton,
    Button,
  } from "element-ui";
  import swal from "sweetalert2";
  import "sweetalert2/dist/sweetalert2.css";
  import ValidationError from "@/components/ValidationError.vue";
  import formMixin from "@/mixins/form-mixin";
  import Multiselect from 'vue-multiselect';
  import PulseLoader from 'vue-spinner/src/PulseLoader.vue';
  
  export default {
    layout: "DashboardLayout",
  
    components: {
      PulseLoader,
      BoxItemNew,
      BoxItem,
      DatePicker,
      ValidationError,
      Multiselect,
      Modal,
      BasePagination,
      [Tooltip.name]: Tooltip,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      [Dropdown.name]: Dropdown,
      [DropdownItem.name]: DropdownItem,
      [DropdownMenu.name]: DropdownMenu,
      [Select.name]: Select,
      [Option.name]: Option,
      [Button.name]: Button,
    },
  
    mixins: [formMixin],
  
    data() {
      return {
        asientoACopiar: null,
        cambiaAsiento: false,
        corridas: [],
        rutas: [],
        layouts: [],
        rutaTramos: [],
        tramosSubcorridas: [],
        tramosSubcorridas_parse: [],
        listaAbordaje: [],
        tramosDeRuta: [],
        corridasEnGrupo: [],
        unidades: [],
        operadores: [],
        selectedRows: [],
        query: null,
        fecha_salida: null,
        hora_salida: null,
        ruta: null,
        terminal_origen: null,
        terminal_destino: null,
        terminales: [],
        respuesta: null,
        hora_salida_select: null,
  
        sort: "created_at",
  
        pagination: {
          perPage: 5,
          currentPage: 1,
          perPageOptions: [{value:'5', descripcion: '5 corridas por página'},
          {value:'10', descripcion: '10 corridas por página'},
          {value:'25', descripcion: '25 corridas por página'},
          {value:'50', descripcion: '50 corridas por página'}],
        },
        total: 0,
        loading: true,
        hasParent: null,
        showAddModal: false,
        showAdminModal: false,
        showGrupoCorridasModal: false,
        showListaAbordajeModal: false,
        showPrintListaAbordajeModal: false,
        showChangeUnidadModal: false,
        showChangeOperadorModal: false,
        showChangeLayoutModal: false,
        validacion: {},

        corrida_layout: null,
        mostrarNivelUno: true,
        mostrarNivelDos: false,
        mostrarNivelUnoNuevo: true,
        mostrarNivelDosNuevo: false,
        cambio_layout: { layout: null },
        new_layout: {
          estructura:[
              [],
              [],
            ]
          },
        corrida_admin: { type: "corrida", active: null, operador1_select: null, operador2_select: null },
        corrida: {
          type: "corrida",
          layout: null,
          ruta: null,
          dias: [],
          fecha_inicio: null,
          fecha_fin: null,
          hora_salida: null,
          tramos: [],
        },
        updateLayout: {
          type: "update layout",
          estructura: [],
          limbo: [],
        },
        disabledButtonLayoutUpdate: false,
        disabledButtonAddCorrida: false,
        dias:[
          { id: 1, nombre: 'Lu', status: true },
          { id: 2, nombre: 'Ma', status: true },
          { id: 3, nombre: 'Mi', status: true },
          { id: 4, nombre: 'Ju', status: true },
          { id: 5, nombre: 'Vi', status: true },
          { id: 6, nombre: 'Sa', status: true },
          { id: 7, nombre: 'Do', status: true },
        ], 
        loadingSpinner: false,
        color: '#0068a0',
        size: '45px',
        grupo_corridas: null,
        grupoCorridaPasa: null,
        countPasaTramos: null,
        cambioCheckGrupoCorrida: 0,
        grupoCorrida_subcorridas: { type: 'subcorridas grupo corrida', tramos_ruta: [] },
        logGrupoCorridas: null,
        ModalLogGrupoCorridas: false,
        totalAsientosLimbo: null,
        asientosLimbo: null,
        TotalVentaCorrida: null,
        destroyingCorrida: false
      };
    },
  
    mounted(){
      //const date = new Date();
      //this.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone.toString();
      this.getRutasActive();
      this.getTerminales();
    },
  
    computed: {
      from() {
        return this.pagination.perPage * (this.pagination.currentPage - 1);
      },
  
      to() {
        let highBound = this.from + this.pagination.perPage;
        if (this.total < highBound) {
          highBound = this.total;
        }
        return highBound;
      },

      selectLayout(){
        if(this.cambio_layout.layout != null){
          return true;
        }else{
          return false;
        }
      }
    },
  
    watch: {
      query: {
        handler: "getListDebounced",
        immediate: true,
      },
      'corrida.ruta'(){
        this.getRutaTramos();
      },
      'corrida.layout'(){
        if(this.validacion.mensaje){
          this.getRutaTramos();
        } else {
          this.validateCorrida();
        }
      },
      'corrida.fecha_inicio'(){
        if(this.validacion.mensaje){
          this.getRutaTramos();
        } else {
          this.validateCorrida();
        }
      },
      'corrida.fecha_fin'(){
        if(this.validacion.mensaje){
          this.getRutaTramos();
        } else {
          this.validateCorrida();
        }
      },
      'corrida.hora_salida'(){
        if(this.validacion.mensaje){
          this.getRutaTramos();
        } else {
          this.validateCorrida();
        }
      },
      fecha_salida: {
        handler: "getListDebounced",
        immediate: true,
      },
      hora_salida: {
        handler: "getListDebounced",
        immediate: true,
      },
      ruta: {
        handler: "getListDebounced",
        immediate: true,
      },
      terminal_origen: {
        handler: "getListDebounced",
        immediate: false,
      },
      terminal_destino: {
        handler: "getListDebounced",
        immediate: false,
      },
      hora_salida_select: {
        handler: "validateCorrida",
        immediate: true,
      },
      pagination: {
        handler: "getList",
        immediate: false,
        deep: true,
      },
      'grupo_corridas.tramos_ruta'(){
        deep: true,
        this.countPasa();
      },
    },
  
    methods: {
      async getTerminales() {
        let params = {
          filter: {
          },
          page: {
            number: 1,
            size: 100000,
          },
        };
        await this.$store.dispatch("terminales/list", params).then(() => {
          this.terminales = this.$store.getters["terminales/list"];
        });
      },
      async imprimirListaAbordaje(){
        //se obtienen datos de usuario autenticado
        let me = await this.$store.getters["profile/me"];
        // imagen a base64
        const getBase64FromUrl = async (url) => {
            const data = await fetch(url);
            const blob = await data.blob();
            return new Promise((resolve) => {
            const reader = new FileReader();
            reader.readAsDataURL(blob); 
            reader.onloadend = () => {
                const base64data = reader.result;   
                resolve(base64data);
            }
            });
        }
        let imagen = await getBase64FromUrl('/img/logoPrinter2.png');
        let printer = new Impresora;
        let tablaClass = Vue.extend(ImpresionListaAbordaje);
        let tablaInstancia = new tablaClass({
            propsData: { 
                lista: this.listaAbordaje,
                user: me.attributes,
                corrida: this.corrida_admin
            }
        });
        let tabla_html = (tablaInstancia.$mount().$el.outerHTML).toString();
        let tabla = this.changeSimbol(tabla_html);
        printer.setAlign("center");
        printer.imagen(imagen);
        printer.setAlign("left");
        printer.html(tabla);
        printer.cut();
        printer.end().then(respuesta => {
            console.log(respuesta);
        });
      },
      changeSimbol(s) {
            var accent_map = {'á':'a', 'é':'e', 'è':'e', 'í':'i','ó':'o','ú':'u','Á':'a', 'É':'e', 'è':'e', 'Í':'i','Ó':'o','Ú':'u', 'Ñ':'N', 'ñ':'n'};
            if (!s) { return ''; }
            var ret = '';
            for (var i = 0; i < s.length; i++) {
                ret += accent_map[s.charAt(i)] || s.charAt(i);
            }
            return ret;
        },
      checkBoxGrupoCorrida(row){
        if(row.pasa === true){
          this.grupoCorrida_subcorridas.tramos_ruta[this.cambioCheckGrupoCorrida] = row; 
          this.cambioCheckGrupoCorrida++;
          this.countPasaTramos++;
        }else{ 
          this.cambioCheckGrupoCorrida--;
          this.countPasaTramos--;
          for(let i = 0; i < this.grupoCorrida_subcorridas.tramos_ruta.length; i++){
            if(this.grupoCorrida_subcorridas.tramos_ruta[i].id === row.id){
              this.grupoCorrida_subcorridas.tramos_ruta.splice(i, 1);
            }
          }
          
        }
      },  

      async getGrupoCorrida(id){
        await this.$store.dispatch("corridas/getGrupoCorridas", id).then(() => {
          this.grupo_corridas = this.$store.getters["corridas/getGrupoCorridas"];
          this.showGrupoCorridasModal = true;
          this.grupoCorridaPasa = this.grupo_corridas.tramos_ruta;
        });
      },

      async createSubCorridas(){
        if(this.cambioCheckGrupoCorrida <= 0){
          this.$notify({
            type: "danger",
            message: "No se realizaron nuevas selecciones de tramos",
            duration: -1
          });
          return;
        }else{
          this.grupoCorrida_subcorridas.grupo_corrida_id = this.corrida_admin.grupo_corrida_id;
          await this.$store.dispatch("corridas/addSubcorridas", this.grupoCorrida_subcorridas).then(() => {
            this.logGrupoCorridas = this.$store.getters["corridas/addSubcorridas"];
            this.logGrupoCorridas = this.logGrupoCorridas.result;
            this.ModalLogGrupoCorridas = true;
          });
        }
      },

      countPasa(){
        let total = 0;
        for(let i = 0; i < this.grupo_corridas.tramos_ruta.length; i++){
          if(this.grupo_corridas.tramos_ruta[i].pasa === 1 || this.grupo_corridas.tramos_ruta[i].pasa === true){
            total++;
          }
        }
        this.countPasaTramos = total;
      },

      closeChangeLayoutModal(){
        this.cambio_layout.layout = null;
        this.corrida_layout = null;
        this.new_layout.estructura[0] = [];
        this.new_layout.estructura[1] = [];
        this.totalAsientosLimbo = null;
        this.asientosLimbo = null;
        this.new_layout.niveles = null;
        this.showChangeLayoutModal = false;
        this.showAdminModal = false;
      },
      createNewLayout(){
        this.new_layout.estructura = JSON.parse(this.cambio_layout.layout.attributes.estructura);
        if(this.new_layout.estructura[1].length > 0){
          this.new_layout.niveles = this.cambio_layout.layout.attributes.niveles;
        }
        if(this.corrida_layout.estructura[1].length > 0){
          for(let i = 0; i < 5; i++){
            for(let j = 0; j < this.corrida_layout.estructura[1][i].length; j++){
              if(this.corrida_layout.estructura[1][i][j] != null){
                if(this.corrida_layout.estructura[1][i][j].tipo === "asiento"){
                  for(let k = 0; k < 5; k++){
                    for(let l = 0; l < this.new_layout.estructura[0][k].length; l++){
                      if(this.new_layout.estructura[0][k][l] != null && this.corrida_layout.estructura[1][i][j] != null){
                        if(this.new_layout.estructura[0][k][l].disponible === undefined){
                          this.new_layout.estructura[0][k][l].disponible = 1;
                        }
                        if(this.new_layout.estructura[0][k][l].tipo === "asiento" && this.corrida_layout.estructura[1][i][j].tipo === "asiento"){
                          if(this.new_layout.estructura[0][k][l].numero === this.corrida_layout.estructura[1][i][j].numero){
                            this.new_layout.estructura[0][k][l].disponible = Number(this.corrida_layout.estructura[1][i][j].disponible);
                            this.new_layout.estructura[0][k][l].boletos = this.corrida_layout.estructura[1][i][j].boletos;
                            this.new_layout.estructura[0][k][l].pantalla = this.corrida_layout.estructura[1][i][j].pantalla;
                            this.new_layout.estructura[0][k][l].cantidadBoletos = this.corrida_layout.estructura[1][i][j].cantidadBoletos;
                            //borra asiento que ya fue pintado en nuevo layout
                            if(this.corrida_layout.estructura[1][i][j].disponible === 0){
                              //const id = 'oldTwo'+i+(j.toString());
                              //const item = this.$refs[id];
                              //item[0].tipo = null;
                              //item[0].numero = null;
                              //item[0].categoria = null;
                              //item[0].pantalla = false;
                              this.corrida_layout.estructura[1][i][j] = null;
                            }
                          }
                        }
                      }
                    }
                    if(this.new_layout.estructura[1].length > 0){
                      for(let l = 0; l < this.new_layout.estructura[1][k].length; l++){
                        if(this.new_layout.estructura[1][k][l] != null && this.corrida_layout.estructura[1][i][j] != null){
                          if(this.new_layout.estructura[1][k][l].disponible === undefined){
                            this.new_layout.estructura[1][k][l].disponible = 1;
                          }
                          if(this.new_layout.estructura[1][k][l].tipo === "asiento"){
                            if(this.new_layout.estructura[1][k][l].numero === this.corrida_layout.estructura[1][i][j].numero){
                              this.new_layout.estructura[1][k][l].disponible = Number(this.corrida_layout.estructura[1][i][j].disponible);
                              this.new_layout.estructura[1][k][l].boletos = this.corrida_layout.estructura[1][i][j].boletos;
                              this.new_layout.estructura[1][k][l].pantalla =  this.corrida_layout.estructura[1][i][j].pantalla;
                              this.new_layout.estructura[1][k][l].cantidadBoletos = this.corrida_layout.estructura[1][i][j].cantidadBoletos;
                              //borra asiento que ya fue pintado en nuevo layout
                              if(this.corrida_layout.estructura[1][i][j].disponible === 0){
                                //const id = 'oldTwo'+i+(j.toString());
                                //const item = this.$refs[id];
                                //item[0].tipo = null;
                                //item[0].numero = null;
                                //item[0].categoria = null;
                                //item[0].pantalla = false;
                                this.corrida_layout.estructura[1][i][j] = null;
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
        if(this.corrida_layout.estructura[0].length > 0){
          for(let i = 0; i < 5; i++){
            for(let j = 0; j < this.corrida_layout.estructura[0][i].length; j++){
              if(this.corrida_layout.estructura[0][i][j] != null){
                if(this.corrida_layout.estructura[0][i][j].tipo === "asiento"){
                  for(let k = 0; k < 5; k++){
                    for(let l = 0; l < this.new_layout.estructura[0][k].length; l++){
                      if(this.new_layout.estructura[0][k][l] != null && this.corrida_layout.estructura[0][i][j] != null){
                        if(this.new_layout.estructura[0][k][l].disponible === undefined){
                          this.new_layout.estructura[0][k][l].disponible = 1;
                        }
                        if(this.new_layout.estructura[0][k][l].tipo === "asiento"){
                          if(this.new_layout.estructura[0][k][l].numero === this.corrida_layout.estructura[0][i][j].numero){
                            this.new_layout.estructura[0][k][l].disponible = Number(this.corrida_layout.estructura[0][i][j].disponible);
                            this.new_layout.estructura[0][k][l].boletos = this.corrida_layout.estructura[0][i][j].boletos;
                            this.new_layout.estructura[0][k][l].pantalla = this.corrida_layout.estructura[0][i][j].pantalla;
                            this.new_layout.estructura[0][k][l].cantidadBoletos = this.corrida_layout.estructura[0][i][j].cantidadBoletos;
                            //borra asiento que ya fue pintado en nuevo layout
                            if(this.corrida_layout.estructura[0][i][j].disponible === 0){
                              const id = 'old'+i+(j.toString());
                              const item = this.$refs[id];
                              item[0].tipo = null;
                              item[0].numero = null;
                              item[0].categoria = null;
                              item[0].pantalla = false;
                              this.corrida_layout.estructura[0][i][j] = null;
                            }
                          }
                        }
                      }
                    }
                    if(this.new_layout.estructura[1].length > 0){
                      for(let l = 0; l < this.new_layout.estructura[1][k].length; l++){
                        if(this.new_layout.estructura[1][k][l] != null && this.corrida_layout.estructura[0][i][j] != null){
                          if(this.new_layout.estructura[1][k][l].disponible === undefined){
                            this.new_layout.estructura[1][k][l].disponible = 1;
                          }
                          if(this.new_layout.estructura[1][k][l].tipo === "asiento"){
                            if(this.new_layout.estructura[1][k][l].numero === this.corrida_layout.estructura[0][i][j].numero){
                              this.new_layout.estructura[1][k][l].disponible = Number(this.corrida_layout.estructura[0][i][j].disponible);
                              this.new_layout.estructura[1][k][l].boletos = this.corrida_layout.estructura[0][i][j].boletos;
                              this.new_layout.estructura[1][k][l].pantalla =  this.corrida_layout.estructura[0][i][j].pantalla;
                              this.new_layout.estructura[1][k][l].cantidadBoletos = this.corrida_layout.estructura[0][i][j].cantidadBoletos;
                              //borra asiento que ya fue pintado en nuevo layout
                              if(this.corrida_layout.estructura[0][i][j].disponible === 0){
                                const id = 'old'+i+(j.toString());
                                const item = this.$refs[id];
                                item[0].tipo = null;
                                item[0].numero = null;
                                item[0].categoria = null;
                                item[0].pantalla = false;
                                this.corrida_layout.estructura[0][i][j] = null;
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      },

      iniciaCambiaAsiento(asiento){
        this.asientoACopiar = asiento;
        this.cambiaAsiento = true;
      },

      terminaCambioAsiento(asientoDondeCopia){
        if(this.mostrarNivelUno){
          for(let i = 0; i < 5; i++){
            for(let j = 0; j < this.corrida_layout.estructura[0][i].length; j++){
              if(this.corrida_layout.estructura[0][i][j] != null){
                if(this.corrida_layout.estructura[0][i][j].seleccionado === true){
                  this.cambiaAsiento = false;
                  this.asientoACopiar = null;
                  const id = 'old'+i+(j.toString());
                  const item = this.$refs[id];
                  item[0].tipo = null;
                  item[0].numero = null;
                  item[0].categoria = null;
                  item[0].pantalla = false;
                  this.corrida_layout.estructura[0][i][j] = null;
                }
              }
            }
            if(this.mostrarNivelUnoNuevo){
              for(let j = 0; j < this.new_layout.estructura[0][i].length; j++){
                if(this.new_layout.estructura[0][i][j] != null){
                  if(this.new_layout.estructura[0][i][j].numero === asientoDondeCopia.numero){
                    const id = 'new'+i+(j.toString());
                    const item = this.$refs[id];
                    item[0].boletos = asientoDondeCopia.boletos;
                    item[0].cantidadBoletos = asientoDondeCopia.cantidadBoletos;
                  }
                }
              }
            }else{
              for(let j = 0; j < this.new_layout.estructura[1][i].length; j++){
                if(this.new_layout.estructura[1][i][j] != null){
                  if(this.new_layout.estructura[1][i][j].numero === asientoDondeCopia.numero){
                    const id = 'new2'+i+(j.toString());
                    const item = this.$refs[id];
                    console.log(item)
                    item[0].boletos = asientoDondeCopia.boletos;
                    item[0].cantidadBoletos = asientoDondeCopia.cantidadBoletos;
                  }
                }
              }
            }
          }
        }
        if(this.mostrarNivelDos){
          for(let i = 0; i < 5; i++){
            for(let j = 0; j < this.corrida_layout.estructura[1][i].length; j++){
              if(this.corrida_layout.estructura[1][i][j] != null){
                if(this.corrida_layout.estructura[1][i][j].seleccionado === true){
                  this.cambiaAsiento = false;
                  this.asientoACopiar = null;
                  const id = 'old2'+i+(j.toString());
                  const item = this.$refs[id];
                  console.log(item)
                  item[0].tipo = null;
                  item[0].numero = null;
                  item[0].categoria = null;
                  item[0].pantalla = false;
                  this.corrida_layout.estructura[1][i][j] = null;
                }
              }
            }
            if(this.mostrarNivelUnoNuevo){
              for(let j = 0; j < this.new_layout.estructura[0][i].length; j++){
                if(this.new_layout.estructura[0][i][j] != null){
                  if(this.new_layout.estructura[0][i][j].numero === asientoDondeCopia.numero){
                    const id = 'new'+i+(j.toString());
                    const item = this.$refs[id];
                    item[0].boletos = asientoDondeCopia.boletos;
                    item[0].cantidadBoletos = asientoDondeCopia.cantidadBoletos;
                  }
                }
              }
            }else{
              for(let j = 0; j < this.new_layout.estructura[1][i].length; j++){
                if(this.new_layout.estructura[1][i][j] != null){
                  if(this.new_layout.estructura[1][i][j].numero === asientoDondeCopia.numero){
                    const id = 'new2'+i+(j.toString());
                    const item = this.$refs[id];
                    console.log(item)
                    item[0].boletos = asientoDondeCopia.boletos;
                    item[0].cantidadBoletos = asientoDondeCopia.cantidadBoletos;
                  }
                }
              }
            }
          }
        }
      },

      getLimbo(){
        let h = 0;
        let k = [];
        if(this.corrida_layout.estructura[0] != null){
          for(let i = 0; i < 5; i++){
            for(let j = 0; j < this.corrida_layout.estructura[0][i].length; j++){
              if(this.corrida_layout.estructura[0][i][j] != null){
                if(this.corrida_layout.estructura[0][i][j].disponible === 0){
                  this.updateLayout.limbo[h] = this.corrida_layout.estructura[0][i][j];
                  h++;
                  k.push(this.corrida_layout.estructura[0][i][j].numero);
                }
              }
            }
          }
        }
        if(this.corrida_layout.estructura[1] != null){
          if(this.corrida_layout.estructura[1].length > 0){
            for(let i = 0; i < 5; i++){
              for(let j = 0; j < this.corrida_layout.estructura[1][i].length; j++){
                if(this.corrida_layout.estructura[1][i][j] != null){
                  if(this.corrida_layout.estructura[1][i][j].disponible === 0){
                    this.updateLayout.limbo[h] = this.corrida_layout.estructura[1][i][j];
                    h++;
                    k.push(this.corrida_layout.estructura[1][i][j].numero);
                  }
                }
              }
            }
          }
        } 
        this.totalAsientosLimbo = h;
        this.asientosLimbo = k;
      },

      async updateLayoutCorrida(){
        this.disabledButtonLayoutUpdate = true;
        this.loadingSpinner = true;
        this.getLimbo();
        this.updateLayout.corrida_id = this.corrida_admin.id;
        this.updateLayout.estructura = this.new_layout.estructura;
        this.updateLayout.layout_id = this.cambio_layout.layout.id;
        if(Number(this.totalAsientosLimbo) > 0){
          const confirmation = await swal.fire({
            title: '¿Está seguro de continuar?',
            text: `El Layout del nuevo autobús es mas pequeño, por lo que se quedan ${this.totalAsientosLimbo} boletos vendidos (${this.asientosLimbo}) sin asignar en la ruta ${this.corrida_admin.ruta_nombre}. Debe asignar dichos pasajeros desde la pantalla de canje masivo.`,
            type: "question",
            buttonsStyling: false,
            showCancelButton: true,
            confirmButtonText: "Confirmar",
            cancelButtonText: "Cancelar",
            confirmButtonClass: "btn btn-lg btn-default hover-apolo",
            cancelButtonClass: "btn btn-lg btn-secondary hover-apolo",
          });
          try {
            if(confirmation.value === true){
              await this.$store.dispatch("corridas/updateLayout", this.updateLayout);
              this.$notify({
                type: "success",
                message: "Layout actualizado satisfactoriamente.",
                duration: -1
              });
              this.resetApiValidation();
              this.loadingSpinner = false;
              this.disabledButtonLayoutUpdate = false;
              this.closeChangeLayoutModal();
            }
          } catch (error) {
            if (error.response.data.errors[0]) {
                this.$notify({
                    type: "danger",
                    message: error.response.data.errors[0].detail,
                    duration: -1
                });
            } else {
                this.$notify({
                    type: "danger",
                    message: "Oops, ha ocurrido un problema!",
                    duration: -1
                });
            }
            this.resetApiValidation();
            this.setApiValidation(error.response.data.errors);
            this.loadingSpinner = false;
            this.disabledButtonLayoutUpdate = false;
          }
        }else{
          try {
            await this.$store.dispatch("corridas/updateLayout", this.updateLayout);
            this.$notify({
              type: "success",
              message: "Layout actualizado satisfactoriamente.",
              duration: -1
            });
            this.resetApiValidation();
            this.loadingSpinner = false;
            this.disabledButtonLayoutUpdate = false;
            this.closeChangeLayoutModal();
          } catch (error) {
            if (error.response.data.errors[0]) {
                this.$notify({
                    type: "danger",
                    message: error.response.data.errors[0].detail,
                    duration: -1
                });
            } else {
                this.$notify({
                    type: "danger",
                    message: "Oops, ha ocurrido un problema!",
                    duration: -1
                });
            }
            this.resetApiValidation();
            this.setApiValidation(error.response.data.errors);
            this.loadingSpinner = false;
            this.disabledButtonLayoutUpdate = false;
          }
        }
      },

      nivelUno(){   
        this.mostrarNivelUno = true;
        this.mostrarNivelDos = false;
      },

      nivelDos(){
        this.mostrarNivelUno = false;
        this.mostrarNivelDos = true;
      },

      nivelUnoNuevo(){   
        this.mostrarNivelUnoNuevo = true;
        this.mostrarNivelDosNuevo = false;
      },

      nivelDosNuevo(){
        this.mostrarNivelUnoNuevo = false;
        this.mostrarNivelDosNuevo = true;
      },

      async showChangeLayout(id){
        this.getLayouts();
        await this.$store.dispatch("corridas/layoutCorrida", id).then(() => {
          this.corrida_layout = this.$store.getters["corridas/layoutCorrida"];
          this.corrida_layout = this.corrida_layout.attributes;
          this.showChangeLayoutModal = true;
        });
      },
      getListDebounced: _.debounce(function () {
        this.getList();
      }, 300),
  
      async getList() {
        if(this.hora_salida != null){
          var hora = this.hora_salida;
          var hora_salida = this.pad(hora.getHours()) + ":" + this.pad(hora.getMinutes());
        }
        let params = {
          ...(this.sort ? { sort: this.sort } : {}),
          filter: {
            ...(this.query ? { search: this.query } : {}),
            ...(this.fecha_salida ? { fecha_salida: this.fecha_salida } : {}),
            ...(hora_salida ? { hora_salida: hora_salida } : {}),
            ...(this.ruta ? { ruta: this.ruta.id } : {}),
            ...(this.terminal_origen ? { terminal_origen: this.terminal_origen.id } : {}),
            ...(this.terminal_destino ? { terminal_destino: this.terminal_destino.id } : {})
          },
          page: {
            number: this.pagination.currentPage,
            size: this.pagination.perPage,
          },
        };
  
        await this.$store.dispatch("corridas/list", params).then(() => {
          this.corridas = this.$store.getters["corridas/list"];
          this.total = this.$store.getters["corridas/listTotal"];
        });
        this.loading = false;
      },
  
      async getLayouts() {
        let params = {
          filter: {
          },
          page: {
            number: 1,
            size: 100000,
          },
        };
        await this.$store.dispatch("layouts/listActive", params).then(() => {
          this.layouts = this.$store.getters["layouts/listActive"];
        });
      },
  
      async getRutasActive() {
        let params = {
          filter: {
          },
          page: {
            number: 1,
            size: 100000,
          },
        };
        await this.$store.dispatch("rutas/list", params).then(() => {
          let rutas = this.$store.getters["rutas/list"];
          this.rutas = rutas.map(ruta => ({
            id: ruta.id,
            nombre: ruta.attributes.nombre
          }));
        });
      },

      async validateCorrida(){
        let validation;
        this.validacion.mensaje = null;
        if(this.corrida.ruta != null && this.hora_salida_select != null && this.corrida.fecha_inicio != null && this.corrida.fecha_fin != null && this.corrida.layout != null){
          this.parseDateUTC6('validacion');
          this.validacion.mensaje = null;
          this.validacion.ruta_id = this.corrida.ruta.id;
          this.validacion.layout_id = this.corrida.layout.id;
          //var hora = this.hora_salida_select;
          //this.validacion.hora_salida = this.pad(hora.getHours()) + ":" + this.pad(hora.getMinutes());
          //var fecha_inicio = this.corrida.fecha_inicio;
          //this.validacion.fecha_inicio = this.pad(fecha_inicio.getFullYear()) + "-" + this.pad(fecha_inicio.getMonth()+1) + "-" + this.pad(fecha_inicio.getDate());
          //var fecha_fin = this.corrida.fecha_fin;
          //this.validacion.fecha_fin = this.pad(fecha_fin.getFullYear()) + "-" + this.pad(fecha_fin.getMonth()+1) + "-" + this.pad(fecha_fin.getDate());
          await this.$store.dispatch("corridas/validate", this.validacion).then(() => {
            this.respuesta = this.$store.getters["corridas/corrida"];
          });

          let respuesta = this.respuesta;

          if(respuesta["success"] !== undefined){
              validation = true;
          }
          if(respuesta["errors"] !== undefined){
              this.validacion.mensaje = this.respuesta.errors[0].detail;
              validation = false;
              this.rutaTramos = [];
              this.corrida.tramos = [];
          }
        }else{
          validation = true;
        }
        return validation;
      },
  
      async getRutaTramos() {
        let validation = await this.validateCorrida();
        if(validation === true){
          if(this.corrida.ruta !== null){
            await this.$store.dispatch("rutas/listRutaTramos", this.corrida.ruta.id).then(() => {
              this.rutaTramos = this.$store.getters["rutas/listRutaTramos"];
            });
          }
        }else{
          this.rutaTramos = [];
          this.corrida.tramos = [];
        }
      },
      
      async listTramosSubcorridas($id){
        await this.$store.dispatch("corridas/listTramosSubcorridas", $id).then(() => {
          this.tramosSubcorridas_parse = this.$store.getters["corridas/listTramosSubcorridas"];
          for(let i = 0; i < this.tramosSubcorridas_parse.length; i++){
            if(this.tramosSubcorridas_parse[i].attributes.pasa === 1){
              this.tramosSubcorridas_parse[i].attributes.pasa = true;
            }else{
              this.tramosSubcorridas_parse[i].attributes.pasa = false;
            }
          }
          this.tramosSubcorridas = this.tramosSubcorridas_parse;
        });
      },

      async activateCorrida($id){
        const confirmation = await swal.fire({
          title: `¿Desea activar corrida?`,
          type: "question",
          buttonsStyling: false,
          showCancelButton: true,
          confirmButtonText: "Activar",
          cancelButtonText: "Cancelar",
          confirmButtonClass: "btn btn-lg btn-default hover-apolo",
          cancelButtonClass: "btn btn-lg btn-secondary hover-apolo",
        });
  
        try {
          if (confirmation.value === true) {
              await this.$store.dispatch("corridas/activate", $id);
              await this.getList();
              this.$notify({
              type: "success",
              message: "Corrida activada satisfactoriamente.",
              duration: -1
            });
            this.corrida_admin.active = 1;
          }
        } catch (error) {
          if (error.response.data.errors[0]) {
            this.$notify({
              type: "danger",
              message: "Oops, ha ocurrido un problema!",
              duration: -1
            });
          } else {
            this.$notify({
              type: "danger",
              message: "Oops, ha ocurrido un problema!",
              duration: -1
            });
          }
        }
      },

      async deactivateCorrida($id){
        const confirmation = await swal.fire({
          title: `¿Desea suspender corrida?`,
          type: "question",
          buttonsStyling: false,
          showCancelButton: true,
          confirmButtonText: "Suspender",
          cancelButtonText: "Cancelar",
          confirmButtonClass: "btn btn-lg btn-default hover-apolo",
          cancelButtonClass: "btn btn-lg btn-secondary hover-apolo",
        });
  
        try {
          if (confirmation.value === true) {
              await this.$store.dispatch("corridas/deactivate", $id);
              await this.getList();
              this.$notify({
              type: "success",
              message: "Corrida suspendida satisfactoriamente.",
              duration: -1
            });
          this.corrida_admin.active = 0;
          }
        } catch (error) {
          if (error.response.data.errors[0]) {
            this.$notify({
              type: "danger",
              message: "Oops, ha ocurrido un problema!",
              duration: -1
            });
          } else {
            this.$notify({
              type: "danger",
              message: "Oops, ha ocurrido un problema!",
              duration: -1
            });
          }
        }
      },

      async destroyCorrida($id){
        const confirmation = await swal.fire({
          title: `¿Está seguro de eliminar la corrida #${$id}?`,
          text: "Esta acción marcará los boletos vendidos 'a blanco' y no se podrá deshacer.",
          type: "warning",
          buttonsStyling: false,
          showCancelButton: true,
          confirmButtonText: "Eliminar",
          cancelButtonText: "Cancelar",
          confirmButtonClass: "btn btn-lg btn-danger hover-apolo",
          cancelButtonClass: "btn btn-lg btn-secondary hover-apolo",
        });
  
        try {
          if (confirmation.value === true) {
            this.destroyingCorrida = true;
            try {
              await this.$store.dispatch("corridas/destroy", $id);
              this.showAdminModal = false;
              await this.getList();
              this.$notify({
                type: "success",
                message: "Corrida eliminada correctamente. Boletos vendidos marcados 'a blanco'.",
                duration: -1
              });
              this.destroyingCorrida = false;
            } catch (error) {
              this.destroyingCorrida = false;
              if (error.response && error.response.status === 409) {
                const soldTicketsCount = error.response.data.result.sold_tickets_count;
                const confirmMessage = error.response.data.result.message;
                const secondConfirmation = await swal.fire({
                  title: `¿Desea continuar con la eliminación?`,
                  text: confirmMessage,
                  type: "warning",
                  buttonsStyling: false,
                  showCancelButton: true,
                  confirmButtonText: "Sí, eliminar",
                  cancelButtonText: "Cancelar",
                  confirmButtonClass: "btn btn-lg btn-danger hover-apolo",
                  cancelButtonClass: "btn btn-lg btn-secondary hover-apolo",
                });
                if (secondConfirmation.value === true) {
                  this.destroyingCorrida = true;
                  await this.$store.dispatch("corridas/destroy", { id: $id, confirm: true });
                  this.showAdminModal = false;
                  await this.getList();
                  this.$notify({
                    type: "success",
                    message: "Corrida eliminada correctamente. Boletos vendidos marcados 'a blanco'.",
                    duration: -1
                  });
                  this.destroyingCorrida = false;
                }
              } else {
                if (error.response && error.response.data.errors && error.response.data.errors[0]) {
                  this.$notify({
                    type: "danger",
                    message: error.response.data.errors[0].detail,
                    duration: -1
                  });
                } else {
                  this.$notify({
                    type: "danger",
                    message: "Oops, ha ocurrido un problema!",
                    duration: -1
                  });
                }
              }
            }
          }
        } catch (error) {
          this.destroyingCorrida = false;
          this.$notify({
            type: "danger",
            message: "Oops, ha ocurrido un problema!",
            duration: -1
          });
        }
      },

      async listaAbordajeModal($id){
        await this.$store.dispatch("corridas/listAbordaje", $id).then(() => {
          this.listaAbordaje = this.$store.getters["corridas/listAbordaje"];
        });
        await this.$store.dispatch("corridas/getTotalVentaCorrida", $id).then(() => {
          this.TotalVentaCorrida = this.$store.getters["corridas/getTotalVentaCorrida"];
        });
        this.showListaAbordajeModal = true;
      },

      async getListUnidades(row){
        await this.$store.dispatch("unidades/listActive").then(() => {
          this.unidades = this.$store.getters["unidades/listActive"];
          if(this.unidades.length > 0 && this.corrida_admin.unidad_id){
            this.corrida_admin.unidad_select = this.unidades.find(item => item.id == this.corrida_admin.unidad_id);
          }
        });
      },

      async getListOperadores(){
        await this.$store.dispatch("operadores/listActive").then(() => {
          this.operadores = this.$store.getters["operadores/listActive"];
          if(this.operadores.length > 0 && this.corrida_admin.operador1_id){
            this.corrida_admin.operador1_select = this.operadores.find(item => item.id == this.corrida_admin.operador1_id);
          }
          if(this.operadores.length > 0 && this.corrida_admin.operador2_id){
            this.corrida_admin.operador2_select = this.operadores.find(item => item.id == this.corrida_admin.operador2_id);
          }
        });
      },

      showChangeUnidad(){
        this.showChangeUnidadModal = true;
      },

      showChangeOperador(){
        this.showChangeOperadorModal = true;
      },

      nombreCompleto ({ nombre, apellidos }) {
        return `${nombre} ${apellidos}`
      },

      changeUnidadTable(row){
        this.hasParent = false;
        this.corrida_admin.id = row.id;
        if(row.relationships.unidad){
          this.corrida_admin.unidad_id = row.relationships.unidad.id;
        }
        this.getListUnidades(row);
        this.showChangeUnidadModal = true;
      },

      changeOperadorTable(row){
        this.hasParent = false;
        this.corrida_admin.id = row.id;
        if(row.relationships.operador1){
          this.corrida_admin.operador1_id = row.relationships.operador1.id;
        }
        if(row.relationships.operador2){
          this.corrida_admin.operador2_id = row.relationships.operador2.id;
        }
        this.getListOperadores(row);
        this.showChangeOperadorModal = true;
      },

      async changeOperador(){
        if(this.corrida_admin.operador1_select){
          this.corrida_admin.operador1_id = this.corrida_admin.operador1_select.id;
        }
        if(this.corrida_admin.operador2_select){
          this.corrida_admin.operador2_id = this.corrida_admin.operador2_select.id;
        }
        try{
          await this.$store.dispatch("corridas/actualiza", this.corrida_admin);
          this.$notify({
            type: "success",
            message: "Operador de corrida actualizado satisfactoriamente.",
            duration: -1
          });
          this.corrida_admin.operador1 = this.corrida_admin.operador1_select.nombre+' '+this.corrida_admin.operador1_select.apellidos;
          if(this.corrida_admin.operador2_select){
            this.corrida_admin.operador2 = this.corrida_admin.operador2_select.nombre+' '+this.corrida_admin.operador2_select.apellidos;
          }
          this.corrida_admin.operador1_select = null;
          this.corrida_admin.operador2_select = null;
          this.showChangeOperadorModal = false;
          this.getList();
        } catch (error) {
          if (error.response.data.errors[0]) {
              this.$notify({
                  type: "danger",
                  message: error.response.data.errors[0].detail,
                  duration: -1
              });
          } else {
              this.$notify({
                  type: "danger",
                  message: "Oops, ha ocurrido un problema!",
                  duration: -1
              });
          }
          this.resetApiValidation();
          this.setApiValidation(error.response.data.errors);
        }
      },

      async changeUnidad(){
        this.corrida_admin.unidad_id = this.corrida_admin.unidad_select.id;
        try{
          await this.$store.dispatch("corridas/actualiza", this.corrida_admin);
          this.$notify({
            type: "success",
            message: "Unidad de corrida actualizada satisfactoriamente.",
            duration: -1
          });
          this.corrida_admin.unidad = this.corrida_admin.unidad_select.numero_economico;
          this.corrida_admin.unidad_select = null;
          this.showChangeUnidadModal = false;
          this.getList();
        } catch (error) {
          if (error.response.data.errors[0]) {
              this.$notify({
                  type: "danger",
                  message: error.response.data.errors[0].detail,
                  duration: -1
              });
          } else {
              this.$notify({
                  type: "danger",
                  message: "Oops, ha ocurrido un problema!",
                  duration: -1
              });
          }
          this.resetApiValidation();
          this.setApiValidation(error.response.data.errors);
        }
      },

      addModal(){
        this.corrida.fecha_inicio = new Date();
        this.corrida.fecha_fin = new Date();
        this.hora_salida_select = new Date();
        this.corrida.layout = null;
        this.corrida.ruta = null;
        this.corrida.hora_salida = null;
        this.corrida.tramos = [];
        this.rutaTramos = [];
        this.corrida.dias = [];
        this.dias = [
              { id: 1, nombre: 'Lu', status: true },
              { id: 2, nombre: 'Ma', status: true },
              { id: 3, nombre: 'Mi', status: true },
              { id: 4, nombre: 'Ju', status: true },
              { id: 5, nombre: 'Vi', status: true },
              { id: 6, nombre: 'Sa', status: true },
              { id: 7, nombre: 'Do', status: true },
            ], 
        this.getLayouts();
        this.getRutasActive();
        this.showAddModal = true;
      },
  
      closeModal() {
        this.getList();
        this.resetApiValidation();
        this.corrida.layout = null;
        this.corrida.ruta = null;
        this.corrida.dias = [];
        for(let i = 0; i < this.dias.length; i++){
          this.dias[i].status = false;
        }
        this.corrida.fecha_inicio = null;
        this.corrida.fecha_fin = null;
        this.hora_salida_select = null;
        this.corrida.hora_salida = null;
        this.corrida.tramos = [];
        this.corrida_admin = { type: "corrida", active: null };
        this.tramosSubcorridas = [];
        if(this.showAddModal == true){
          this.showAddModal = false;
        }else{
          this.showAdminModal = false;
        }
      },
      //metodo para controlar por donde pasa la corrida (checkboxes)
      handleSelectionChange(val){
        this.corrida.tramos = [];
        
        for(let i = 0; i < val.length; i++){
          this.corrida.tramos.push(val[i]);
        }
      },
      parseDateUTC6(status){
        var hora = this.hora_salida_select;
        var fecha_inicio = this.corrida.fecha_inicio;
        var fecha_fin = this.corrida.fecha_fin;
        if(status === 'validacion'){
          this.validacion.hora_salida = this.pad(hora.getHours()) + ":" + this.pad(hora.getMinutes())+':00';
          var inicio = this.$moment( this.$moment(fecha_inicio).format('YYYY-MM-DD') + ' ' +  this.$moment(hora).format('HH:mm') );
          var fin = this.$moment( this.$moment(fecha_fin).format('YYYY-MM-DD') + ' ' +  this.$moment(hora).format('HH:mm') );
          //var tz = 'America/Mexico_City';
          //this.validacion.fecha_inicio = inicio.clone().tz(tz).format("YYYY-MM-DD");
          //this.validacion.fecha_fin = fin.clone().tz(tz).format("YYYY-MM-DD");
          //this.validacion.hora_salida = fin.clone().tz(tz).format("HH:mm");
          this.validacion.fecha_inicio = inicio.format("YYYY-MM-DD");
          this.validacion.fecha_fin = fin.format("YYYY-MM-DD");
          this.validacion.hora_salida = fin.format("HH:mm");
        }else{
          //this.corrida.hora_salida = this.pad(hora.getHours()) + ":" + this.pad(hora.getMinutes())+':00'+'-'+this.pad(hora.getTimezoneOffset() / 60+':00');
          this.corrida.fecha_inicio_original = this.corrida.fecha_inicio;
          this.corrida.fecha_fin_original = this.corrida.fecha_fin;
          this.corrida.hora_salida = this.pad(hora.getHours()) + ":" + this.pad(hora.getMinutes())+':00';
          var inicio = this.$moment( this.$moment(fecha_inicio).format('YYYY-MM-DD') + ' ' +  this.$moment(hora).format('HH:mm') );
          var fin = this.$moment( this.$moment(fecha_fin).format('YYYY-MM-DD') + ' ' +  this.$moment(hora).format('HH:mm') );
          //var tz = 'America/Mexico_City';
          //this.corrida.fecha_inicio = inicio.clone().tz(tz).format("YYYY-MM-DD");
          //this.corrida.fecha_fin = fin.clone().tz(tz).format("YYYY-MM-DD");
          //this.corrida.hora_salida = fin.clone().tz(tz).format("HH:mm");
          this.corrida.fecha_inicio = inicio.format("YYYY-MM-DD");
          this.corrida.fecha_fin = fin.format("YYYY-MM-DD");
          this.corrida.hora_salida = fin.format("HH:mm");
        }
        
      },
      async addCorrida(){
        //this.corrida.tramos = this.rutaTramos.filter(item => item.selected == true);
        //se agregan dias seleccionados
        for(let i = 0; i < this.dias.length; i++){
          if(this.dias[i].status == true){
            this.corrida.dias[i] = this.dias[i].id;
          } 
        }
        
        if(this.hora_salida_select !== null){
          this.parseDateUTC6('guardar');
        }

        //let hora = this.hora_salida_select;
        //this.corrida.hora_salida = this.pad(hora.getHours()) + ":" + this.pad(hora.getMinutes());
        if(this.corrida.ruta !== null){
          this.corrida.ruta_id = this.corrida.ruta.id;
        }else{
          this.corrida.ruta_id = null;
        }
        if(this.corrida.layout !== null){
          this.corrida.layout_id = this.corrida.layout.id;
        }else{
          this.corrida.layout_id = null;
        }
        this.disabledButtonAddCorrida = true;
        this.loadingSpinner = true;
        try {
        await this.$store.dispatch("corridas/add", this.corrida);
        this.$notify({
          type: "success",
          message: "Corrida creada satisfactoriamente.",
          duration: -1
        });
        this.resetApiValidation();
        this.disabledButtonAddCorrida = false;
        this.loadingSpinner = false;
        this.closeModal();
        } catch (error) {
          if (error.response.data.errors[0]) {
              this.$notify({
                  type: "danger",
                  message: error.response.data.errors[0].detail,
                  duration: -1
              });
          } else {
              this.$notify({
                  type: "danger",
                  message: "Oops, ha ocurrido un problema!",
                  duration: -1
              });
          }
          //this.corrida.fecha_inicio = this.corrida.fecha_inicio_original;
          //this.corrida.fecha_fin = this.corrida.fecha_fin_original;
          this.disabledButtonAddCorrida = false;
          this.loadingSpinner = false;
          this.corrida.fecha_inicio = this.corrida.fecha_inicio_original;
          this.corrida.fecha_fin = this.corrida.fecha_fin_original;
          this.resetApiValidation();
          this.setApiValidation(error.response.data.errors);
        }
      },

      pad(value) {
        if(value < 10) {
            return '0' + value;
        } else {
            return value;
        }
      },
  
      adminCorrida(row) {
        this.hasParent = true;
        this.getListUnidades(row);
        this.getListOperadores(row);
        this.listTramosSubcorridas(row.id);
        this.resetApiValidation();
        this.corrida_admin.id = row.id;
        this.corrida_admin.grupo_corrida_id = row.attributes.grupo_corrida_id;
        this.corrida_admin.active = row.attributes.active;
        this.corrida_admin.layout_nombre = row.relationships.layout.nombre +' ('+ row.relationships.layout.numero_asientos +' asientos)';
        this.corrida_admin.ruta_nombre = row.relationships.grupo_corrida.ruta.nombre +' ('+ row.relationships.grupo_corrida.ruta.terminal_origen.abreviatura +'-'+ row.relationships.grupo_corrida.ruta.terminal_destino.abreviatura +')';
        this.corrida_admin.fecha_salida= row.attributes.fecha_salida;
        var hora = row.attributes.hora_salida.split(':');
        var hora_salida = this.pad(hora[0]) + ":" + this.pad(hora[1]);
        this.corrida_admin.hora_salida = hora_salida;
        this.corrida_admin.fecha_inicio = row.relationships.grupo_corrida.fecha_inicio;
        this.corrida_admin.fecha_fin = row.relationships.grupo_corrida.fecha_fin;
        this.corrida_admin.dias = [];
        var dias = row.relationships.grupo_corrida.dias.split(',');
        for(let i=0; i < dias.length; i++){
          this.corrida_admin.dias[i] = this.dias.find(item => item.id == dias[i]);
        }
        if(row.relationships.unidad){
          this.corrida_admin.unidad = row.relationships.unidad.numero_economico;
          this.corrida_admin.unidad_id = row.relationships.unidad.id;
        }else{
          this.corrida_admin.unidad = row.relationships.unidad;
        }
        if(row.relationships.operador1){
          this.corrida_admin.operador1 = ' ';
          this.corrida_admin.operador1 = row.relationships.operador1.nombre+' '+row.relationships.operador1.apellidos;
          this.corrida_admin.operador1_id = row.relationships.operador1.id;
        }else{
          this.corrida_admin.operador1 = row.relationships.operador1;
        }
        if(row.relationships.operador2){
          this.corrida_admin.operador2 = ' ';
          this.corrida_admin.operador2 = row.relationships.operador2.nombre+' '+row.relationships.operador2.apellidos;
          this.corrida_admin.operador2_id = row.relationships.operador2.id;
        }else{
          this.corrida_admin.operador2 = row.relationships.operador2;
        }
        this.showAdminModal = true;
      },
  
      async updateCorrida() {
        this.corrida_admin.tramos_subcorridas = this.tramosSubcorridas;
        for(let i = 0; i < this.tramosSubcorridas.length; i++){
          if(this.corrida_admin.tramos_subcorridas[i].attributes.pasa === true){
            this.corrida_admin.tramos_subcorridas[i].attributes.pasa = 1;
          }else{
            this.corrida_admin.tramos_subcorridas[i].attributes.pasa = 0;
          }
        }
        try{
          await this.$store.dispatch("corridas/update", this.corrida_admin);
          this.$notify({
            type: "success",
            message: "Sub-corridas actualizadas satisfactoriamente.",
            duration: -1
          });
          this.listTramosSubcorridas(this.corrida_admin.id);
          this.closeModal();
          this.getList();
        } catch (error) {
          if (error.response.data.errors[0]) {
              this.$notify({
                  type: "danger",
                  message: error.response.data.errors[0].detail,
                  duration: -1
              });
          } else {
              this.$notify({
                  type: "danger",
                  message: "Oops, ha ocurrido un problema!",
                  duration: -1
              });
          }
          this.resetApiValidation();
          this.setApiValidation(error.response.data.errors);
        }
      },
  
      sortChange({ prop, order }) {
        if (order === "descending") {
          this.sort = `-${prop}`;
        } else {
          this.sort = `${prop}`;
        }
        this.getList();
      },
    },
  };
  </script>
  <style lang="scss">
  .table-container{
    //width: 100em;
    overflow-x: auto !important;
    white-space: nowrap !important;
  }

  .argon-error {
    position: relative;
    bottom: 25px !important;
    color: #fb6340;
  }

  .el-checkbox__inner::after{
    background-color: #0068a0 !important;
  }
  
  </style>